import { ShipmentEvent } from '@/model';
import { buildShipmentEvent, buildShipmentEvents } from '@/util';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentEventController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findAllByShipment(shipmentId: number): Promise<ShipmentEvent[]> {
    const response = await this.http.get<ShipmentEvent[]>(
      `${shipmentId}/event`,
    );
    return buildShipmentEvents(response.data);
  }

  async create(
    shipmentId: number,
    event: ShipmentEvent,
  ): Promise<ShipmentEvent> {
    const response = await this.http.post<ShipmentEvent>(
      `${shipmentId}/event`,
      event,
    );
    return buildShipmentEvent(response.data);
  }

  async update(
    shipmentId: number,
    shipmentEvent: ShipmentEvent,
  ): Promise<ShipmentEvent> {
    const response = await this.http.put<ShipmentEvent>(
      `${shipmentId}/event`,
      shipmentEvent,
    );
    return buildShipmentEvent(response.data);
  }

  async delete(
    shipmentId: number,
    event: ShipmentEvent,
  ): Promise<ShipmentEvent> {
    if (!event.id) {
      throw new Error('Id is required to perform delete');
    }
    const response = await this.http.delete<ShipmentEvent>(
      `/${shipmentId}/event/${event.id}`,
    );
    return buildShipmentEvent(response.data);
  }
}
